export default {
  home: {
    matchups: {
      today: "Matchups d'aujourd'hui",
      thisWeek: "Matchups de cette semaine",
      upcoming: "Matchups à venir",
    },
    actions: {
      showMore: "Afficher plus",
      showLess: "Afficher moins",
    },
    empty: {
      parlayMinGames: "Aucune tendance disponible pour le moment. Minimum de 3 matchs requis.",
    },
    hundredPercentClub: {
      subtitle: "Props qui ont touché dans 100% des matchs",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Trouvez de la valeur quand les alignements partants changent. Inclus avec",
        injuryImpact: "Voyez comment les blessures influencent les coéquipiers. Inclus avec",
        opponentRank: "Exploitez les matchups défensifs favorables. Inclus avec",
        startingPitchers: "Ciblez les situations contre des lanceurs vulnérables. Inclus avec",
        weatherReport: "Utilisez le vent et la météo à votre avantage. Inclus avec",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Chargement des marchés...",
        loadError: "Impossible de charger les marchés.",
      },
    },
    sidebar: {
      improveExperience: "Améliorez votre expérience Linemate",
      getAccess: "OBTENEZ ACCÈS À DES JEUX AVANCÉS ET À DES ANALYSES PLUS POUSSÉES",
    },
  },
};
